import { render } from "./editMeal.vue?vue&type=template&id=131cdf54&scoped=true"
import script from "./editMeal.vue?vue&type=script&lang=js"
export * from "./editMeal.vue?vue&type=script&lang=js"

import "./editMeal.vue?vue&type=style&index=0&id=131cdf54&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131cdf54"]])

export default __exports__